const linkBLocks = document.getElementsByClassName('button-link-block');
for (let linkBLock of linkBLocks) {
    const popupButton = linkBLock.querySelector('.button-link-block__link, .button-link-block__video');
    const popupContent = linkBLock?.querySelector('.button-link-modal');
    if (popupContent) {
        popupButton?.addEventListener('click', () => {
            popupContent.classList.add('modal--show');
        });
    }
}